<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="closeModal()")
      .modal-wrapper.modalCards(@click.self="closeModal()")
        .modal-container(:style="{ width: width + 'px' }")
          .modal-header(:class="['header-' + modalType]")
            .title {{ titulo }}
            .header-icon

            el-button.btn#btn(
              type="text",
              @click="closeModal()",
              @mouseover.native="hover",
              @mouseout.native="leave",
              size="mini"
            )
              i.material-icons.icon close

          .modal-body
            slot(name="body")
          .modal-footer
            slot(name="footer")
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 800
    },
    modalType: {
      type: String,
      default: 'default'
    },
    titulo: {
      type: String,
      required: true
    }
  },

  methods: {
    hover () {
      this.colorCopy = this.hoverColor
    },

    leave () {
      this.colorCopy = this.cor
    },
    closeModal () {
      this.$emit('closeCardModal')
    }
  },

  computed: {
    getColor () {
      if (this.colorCopy) {
        return `color: ${this.colorCopy}`
      }
      return ''
    }
  }

}
</script>

<style lang="scss" scoped>

.modal-mask {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  margin-top: 8vh;
}

@media (max-width: 780px) {
  .modal-wrapper {
    width: 375px;
  }
}

.modal-container {
  min-height: 200px;
  max-height: 84vh;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.modal-body {
  padding: 10px;
  margin: 10px 0;
  overflow-y: auto;
  max-height: 76vh;
  flex-grow: 1;
}

.modal-footer {
  padding: 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #FFF;
  margin-left: 3%;
  width: 325px;
}

.btn {
  padding-right: 20px;
  color: #FFF;

  .icon {
    font-size: 18px;
    font-weight: bold;
  }

  &:hover {
    .icon {
      opacity: 0.8;
    }
  }
}

/* Custom headers */
.header-default {
  background-color: #3D9C67;
}

.header-green {
  background-color: #1ABC9C;
  .header-icon {
    background: transparent url('~@/assets/icons/bandeira_reverse.svg') 0% 0% no-repeat padding-box;
    background-position-x: left;
    background-position-y: center;
    height: 100%;
    width: 100%;
    background-size: 25px 35px;
  }
}

.header-yellow {
  background-color: #F1C40F;
  .header-icon {
    background: transparent url('~@/assets/icons/pasta_reverse.svg') 0% 0% no-repeat padding-box;
    background-position-x: left;
    background-position-y: center;
    height: 100%;
    width: 100%;
    background-size: 25px 35px;
  }
}

.header-blue {
  background-color: #3498DB;
  .header-icon {
    background: transparent url('~@/assets/icons/relatorio_reverse.svg') 0% 0% no-repeat padding-box;
    background-position-x: left;
    background-position-y: center;
    height: 100%;
    width: 100%;
    background-size: 25px 35px;
  }
}

.header-red {
  background-color: #E74C3C;
  .header-icon {
    background: transparent url('~@/assets/icons/caixa_reverse.svg') 0% 0% no-repeat padding-box;
    background-position-x: left;
    background-position-y: center;
    height: 100%;
    width: 100%;
    background-size: 25px 35px;
  }
}

@media only screen and (max-width: 1024px){
  .modal-container {
    width: 90% !important;
  }

  .modalCards {
    width: 415px !important;
    position: relative;
    right: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppModalDashboard.vue